import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { Alert, Badge, Button, Card, Input } from '../../components/ui';
import { api, ApiError } from '../../lib/api';

interface SA {
  id: string;
  email: string;
  addedBy: string;
  addedAt: string;
  pendingEmail?: boolean;
}
export function SuperAdminsPage() {
  const { t } = useTranslation();
  const [list, setList] = useState<SA[]>([]);
  const [email, setEmail] = useState('');
  const [err, setErr] = useState<string | null>(null);
  const load = () =>
    api<{ superAdmins: SA[] }>('/api/v1/superadmin/superadmins').then((r) => setList(r.superAdmins));
  useEffect(() => {
    void load();
  }, []);
  const run = async (fn: () => Promise<unknown>) => {
    setErr(null);
    try {
      await fn();
      await load();
    } catch (e) {
      setErr(e instanceof ApiError ? t([`sa.err_${e.code}`, 'sa.err_generic'], { code: e.code }) : String(e));
    }
  };
  return (
    <div className="mx-auto max-w-2xl space-y-4">
      <div className="flex items-center gap-3">
        <Link to="/superadmin" className="text-sm text-emerald-700 underline">
          ← {t('sa.back')}
        </Link>
        <h1 className="text-2xl font-semibold">{t('sa.superadmins')}</h1>
      </div>
      {err && <Alert>{err}</Alert>}
      <Card title={t('sa.addSuperAdmin')}>
        <div className="flex gap-2">
          <Input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="name@nurie.ai"
          />
          <Button
            onClick={() =>
              void run(() => api('/api/v1/superadmin/superadmins', { method: 'POST', json: { email } })).then(
                () => setEmail(''),
              )
            }
            disabled={!email}
          >
            {t('sa.add')}
          </Button>
        </div>
      </Card>
      <Card>
        <ul className="divide-y divide-slate-100 text-sm">
          {list.map((s) => (
            <li key={s.id} className="flex items-center gap-3 py-2">
              <span>{s.email}</span>
              {s.pendingEmail && <Badge tone="amber">{t('sa.pending')}</Badge>}
              <span className="ml-auto text-xs text-slate-500">
                {s.addedBy} · {s.addedAt.slice(0, 10)}
              </span>
              <Button
                variant="danger"
                onClick={() =>
                  void run(() =>
                    api(`/api/v1/superadmin/superadmins/${encodeURIComponent(s.id)}`, { method: 'DELETE' }),
                  )
                }
              >
                {t('sa.remove')}
              </Button>
            </li>
          ))}
        </ul>
      </Card>
    </div>
  );
}
